<script lang="ts">
	import SchedulesTimePicker from 'src/components/DevicesSettings/Schedules/SchedulesG2/DateTimePickers/SchedulesTimePicker.svelte';

	export let editableObject;

	$: console.warn(editableObject.schedule);
</script>

<SchedulesTimePicker bind:schedule={editableObject.schedule} showOption={false} />
